import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { FRONTEND_URL } from '../const';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component'; 

function AdvSlider(props) {

    const slider_list = props.slider_list;

    const formatDetails = (details) => {
        let formatedDetails = details.substring(0, 40) + " ...";
        return <span data-toggle="tooltip" title={details}>
            {formatedDetails};
        </span>
    }

    return (
        <section className='common-space-both px-5'>
            <div className='container'>
                <div className='common-title text-center'>
                    <h2 className='center-line'>{props.title}</h2>
                </div>

                {/* Swiper Pagination */}

            </div>
            <Swiper
                spaceBetween={10}
                slidesPerView={8}  // Show 5 slides at once
                // loop={true}       // Enable infinite loop
                autoplay={{
                    delay: 1000, // Set autoplay delay (in milliseconds)
                    disableOnInteraction: false,  // Continue autoplay after interaction
                }}
                centeredSlides={false}
                modules={[Pagination, Navigation]}
                pagination={{
                    el: '.swiper-pagination',
                    clickable: true,  // Enable clickable pagination
                }}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                breakpoints={{
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,  // Show 1 slide on very small screens
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,  // Show 2 slides on small screens
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 3,  // Show 3 slides on tablets
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: 4,  // Show 5 slides on medium-large screens
                    },
                    // when window width is >= 1440px
                    1440: {
                        slidesPerView: 5,  // Show 8 slides on large screens (default)
                    },
                }}
                className="mySwiper"

            >
                {slider_list.map((item, i) => (
                    <SwiperSlide key={i}>
                        <div className='border border-[#57575733] rounded-xl p-3 slider-box' style={{height: "475px"}}>
                            <div className='img-div mb-3'>
                                <LazyLoadImage
                                className='rounded-xl h-[260px] w-full object-fit-cover'
                                alt={item.name}
                                effect={"opacity"}
                                threshold={100}
                                // height={image.height}
                                loading="lazy"
                                src={`${FRONTEND_URL}${item.image_path}`} // use normal <img> attributes as props
                                // width={image.width} 
                                />
                                {/* <img alt="" src={`${FRONTEND_URL}${item.image_path}`} className='rounded-xl h-[260px] w-full object-fit-cover' /> */}
                            </div>
                            <Link to={`/company-details/${item._id}`}>
                                <p>{item.name}</p>
                            </Link>
                            {item.details ? formatDetails(item.details) : "No Description"}
                            {item.location && <div className='flex gap-2 items-center text-black my-2'>
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="36" height="36" rx="18" fill="#F4F4F4" />
                                    <path d="M11.3334 16.4528C11.3334 12.7049 14.3181 9.66669 18 9.66669C21.6819 9.66669 24.6667 12.7049 24.6667 16.4528C24.6667 20.1712 22.5389 24.5104 19.2192 26.0621C18.4453 26.4238 17.5548 26.4238 16.7809 26.0621C13.4611 24.5104 11.3334 20.1712 11.3334 16.4528Z" stroke="black" strokeWidth="1.5" />
                                    <circle cx="18" cy="16.3333" r="2.5" stroke="black" strokeWidth="1.5" />
                                </svg>
                                {item.location}
                            </div>}
                            <div className='border-t border-[#57575733] pt-2'>
                                <div className='flex items-center justify-between'>
                                    <div>
                                        <span>Views: <span className='text-black font-semibold'>{item.view ?? 0}</span></span>
                                    </div>
                                    <div>
                                        <span>
                                            {item.url ? 
                                                <a href={item.url} target="_blank" rel="noopener noreferrer" className="mt-3 font-semibold text-black text-lg flex">
                                                    <span className="inset-0" />
                                                    <svg className='ml-auto' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13 11L22 2M22 2H16.6562M22 2V7.34375" stroke="black" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2" stroke="black" strokeWidth="1.5" stroke-linecap="round" />
                                                    </svg> 
                                                </a> : 
                                                <>No Link</>
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className='cust-pagination-slider relative mt-10'>
                <div className="swiper-button-prev">
                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 7H1M1 7L7 1M1 7L7 13" stroke="#575757" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div className="swiper-pagination"></div>
                <div className="swiper-button-next">
                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 7H17M17 7L11 1M17 7L11 13" stroke="#575757" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>

        </section>
    );
}

export default AdvSlider;